import { authRequest } from './apiSetup';
import { API_ENDPOINTS } from '../../constants/api-endpoints';

/*
 * Quizzes API
 ** */

export async function getQuizzes(idToken) {
  const endpoint = API_ENDPOINTS.quizzes.replace(/:FILE_ID/, '');
  const response = await authRequest(idToken, { method: 'GET', endpoint });
  return response.data;
}

export async function deleteQuiz(idToken, { fileId }) {
  const endpoint = API_ENDPOINTS.quizzes.replace(/:FILE_ID/, fileId);
  const response = await authRequest(idToken, { method: 'DELETE', endpoint });
  return response.state === 1;
}

export async function updateQuizName(idToken, { id, name }) {
  const endpoint = API_ENDPOINTS.quizzes.replace(/:FILE_ID/, id);
  const response = await authRequest(idToken, { method: 'PUT', endpoint, body: JSON.stringify(name) });
  return response.state === 1;
}
